import {
  monserratRegular,
  robotoRegular,
  scarpaGray500,
  scarpaGray800,
  white,
} from '@habitech/shared';
import styled from 'styled-components';

const ContainerTotal = styled.div`
  display: block !important;
  &:focus-visible {
    outline: none;
  }
`;

export const ContainerModalRule = styled.div`
  position: relative;
  border-radius: 6px;
  width: 336px;
  margin: 5% auto;
  justify-self: center;
  align-self: center;
  background: ${white};
  outline: none;
  padding: 35px 20px 19px 22px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.1);
  overflow-y: auto;
  .icon-close {
    color:${scarpaGray500}
    font-size: 19px;
    position: absolute;
    right: 19px;
    top: 19px;

    &:hover {
      cursor: pointer;
    }
  }
  .icon{
    margin-right: 12px;
  }
  .primary{
    padding: 12px !important;
  }
`;

export const ModalImage = styled.div`
  text-align: center;
  margin: 16px 0;
`;

export const ModalContent = styled.div`
  .title {
    font-family: ${monserratRegular};
    font-size: 24px;
    font-weight: 600;
    color: ${scarpaGray800};
  }
  .title2 {
    font-family: ${robotoRegular};
    font-size: 16px;
    font-weight: 600;
    color: ${scarpaGray800};
    margin: 8px 0;
  }
  .subtitle {
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
    color: ${scarpaGray500};
    margin-bottom: 16px;
    margin-top: 8px;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 40px;
  .space {
    width: 8px;
  }
`;

export default ContainerTotal;
